import ErrorAlert from "@/utility/ErrorAlert";
import http from "../axios/http-common";

export enum EnFormulirCategory {
  KlaimRehabMedis = "klaim-ralan-rehab-medik",
  UjiFungsiKfr = "uji-fungsi-kfr",
  AsesmenOkupasiTerapi = "asesmen-okupasi-terapi",
  AsesmenTerapiWicara = "asesmen-terapi-wicara",
  AsesmenFisioterapi = "asesmen-fisioterapi"
}

class CommonSuket {
  category: string = null;

  constructor(cat: string) {
    this.category = cat;
  }

  async create(data) {
    const response = await http
      .postData(`/formulir/${this.category}`, data)
      .catch(err => {
        ErrorAlert.showErrorAlert(err);

        return Promise.reject(err);
      });

    return response;
  }

  async update(id, data) {
    const response = await http
      .putData(`/formulir/${this.category}/${id}`, data)
      .catch(err => {
        ErrorAlert.showErrorAlert(err);

        return Promise.reject(err);
      });

    return response;
  }

  async getByRegister(register_id: string | number) {
    const response = await http
      .getData(`/register/${register_id}/formulir/${this.category}`)
      .catch(err => {
        ErrorAlert.showErrorAlert(err);

        return Promise.reject(err);
      });

    return response.data;
  }

  async find(id: number) {
    const response = await http
      .getData(`/formulir/${this.category}/${id}`)
      .catch(err => {
        ErrorAlert.showErrorAlert(err);

        return Promise.reject(err);
      });

    return response.data;
  }

  async destroy(id: number) {
    const response = await http
      .deleteData(`/formulir/${this.category}/${id}`)
      .catch(err => {
        ErrorAlert.showErrorAlert(err);

        return Promise.reject(err);
      });

    return response.data;
  }

  async sign(id: number, data) {
    const response = await http
      .postData(`/formulir/${this.category}/${id}/signature`, data)
      .catch(err => {
        ErrorAlert.showErrorAlert(err);

        return Promise.reject(err);
      });

    return response.data;
  }

  print(id) {
    window.open(
      `${http.getAPI()}/formulir/${this.category}/${id}/pdf`,
      "_blank"
    );
  }
}

export default CommonSuket;
